interface Params {
  endDate: string
  startDate: string
  id: string
}

export const getChannelsSourcesSum = ({ endDate, startDate, id }: Params) => {
  return `SELECT COUNT(DISTINCT stats.source_id) FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' AND stats.channel_id = '${id}'`
}
